import { render, staticRenderFns } from "./ArticleVerticalHead.vue?vue&type=template&id=d855cf00&scoped=true&"
import script from "./ArticleVerticalHead.vue?vue&type=script&lang=js&"
export * from "./ArticleVerticalHead.vue?vue&type=script&lang=js&"
import style0 from "./ArticleVerticalHead.vue?vue&type=style&index=0&id=d855cf00&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d855cf00",
  null
  
)

export default component.exports